<template>
  <v-radio-group
    :model-value="preference"
    color="primary"
    density="compact"
    hide-details
    aria-label="Nom du site"
    @update:model-value="select"
  >
    <v-radio :value="autoValue" :label="`Selon l'adresse du site (${domainName.label})`"></v-radio>
    <v-radio v-for="option in options" :key="option.value" :value="option.value" :label="option.label"></v-radio>
  </v-radio-group>
</template>

<script>
  import {
    AUTO_SITE_NAME,
    SITE_NAMES,
    getDomainSiteName,
    getSiteNamePreference,
    setSiteNamePreference,
  } from "@/services/SiteName.service";

  // Name shown in the app bar and the welcome screen, applied right away and remembered on this device.
  export default {
    name: "SiteNameSelector",
    data: () => ({
      autoValue: AUTO_SITE_NAME,
      options: Object.entries(SITE_NAMES).map(([value, name]) => ({ value, label: name.label })),
      domainName: getDomainSiteName(),
    }),
    computed: {
      preference() {
        return getSiteNamePreference();
      },
    },
    methods: {
      select(preference) {
        setSiteNamePreference(preference);
      },
    },
  };
</script>
